// Младший аналитик — deathrattle: «+1 Влияния».
// Триггер: смерть карты с id 'deus_mladshiy_analitik'.

import { addInfluence } from './influence.js';

export const CARD_ID = 'deus_mladshiy_analitik';

export function analitikDeathrattle(state, ownerIdx) {
  addInfluence(state, ownerIdx, 1, 'Аналитик [предсмертный хрип]');
}
